import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = 'nominas/aplicaciones-contribuciones';

/**
 * GET Aplicaciones Contribuciones
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getAplicacionesContribuciones = async () => {
  try {
    const response = await API.get(baseURI);
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Aplicacion Contribucion
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getAplicacionContribucion = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Aplicacion Contribucion
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postAplicacionContribucion = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Aplicacion Contribucion
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchAplicacionContribucion = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Aplicacion Contribucion
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteAplicacionContribucion = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
